import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/MAD-White-1.png";
import "./TopNavigation.css";

const TopNavigation = () => {
    return (
        <div className="top-navigation">
            <img src={logo} alt="Micah Alyse Design Logo" className="logo" />
            <nav className="navigation">
                <ul>
                    <li><Link to="/">HOME</Link></li>
                    <li><Link to="/work">WORK</Link></li>
                    <li><Link to="/about">ABOUT</Link></li>
                    <li><Link to="/contact">CONTACT</Link></li>
                </ul>
            </nav>
        </div>
    );
};

export default TopNavigation;





